module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar"
  }, [_c('router-link', {
    staticClass: "footer-btn",
    attrs: {
      "to": "/videoCategory"
    }
  }, [_vm._v("\n    最新视频\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-btn",
    attrs: {
      "to": "/testnew"
    }
  }, [_vm._v("\n    产品信息\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "footer-btn",
    attrs: {
      "to": "/Personal"
    }
  }, [_vm._v("\n   个人中心\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bad00826"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 237
// module chunks = 46